import type { SnapshotOrInstance } from "@gadgetinc/mobx-quick-tree";
import { extend, register, types } from "@gadgetinc/mobx-quick-tree";
import { ShopifyBaseAdminConnectionConfig } from "./ShopifyBaseAdminConfig";
import { ShopifyLegacyAdminAppConfig } from "./ShopifyLegacyAdminAppConfig";

/**
 * See packages/state-trees/src/connections/ShopifyConnectionConfig.ts for documentation
 * on the different types of Shopify configurations
 */
@register
export class ShopifyLegacyAdminConnectionConfig extends extend(
  ShopifyBaseAdminConnectionConfig("ShopifyManualConnectionConfig", ShopifyLegacyAdminAppConfig),
  {
    appConfigs: types.map(ShopifyLegacyAdminAppConfig),
  }
) {
  get appConfigsAsArray(): ShopifyLegacyAdminAppConfig[] {
    return Array.from(this.appConfigs.values());
  }

  putAppConfig(config: SnapshotOrInstance<typeof ShopifyLegacyAdminAppConfig>): ShopifyLegacyAdminAppConfig {
    return this.appConfigs.put(config);
  }
  removeAppConfig(configKey: string): boolean {
    return this.appConfigs.delete(configKey);
  }
}
